<span class="fdx-c-loading-indicator fdx-c-loading-indicator--small">
  <span class="fdx-c-loading-indicator__part"></span>
  <span class="fdx-c-loading-indicator__part"></span>
  <span class="fdx-c-loading-indicator__part"></span>
  <span class="fdx-c-loading-indicator__part"></span>
</span>
